// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/.store/css-loader@3.6.0/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".question-group .answer_group{align-items:center;line-height:48px;background-color:#fff;color:#303133;font-size:13px;font-weight:500;transition:border-bottom-color .3s;outline:0}.question-group .answer_group .space_group_list{border-bottom:1px solid #ddd;position:relative}.question-group .answer_group .points_list{border-bottom:1px solid #ddd}.space_group_items.el-input.el-input--mini{width:48px}", ""]);
// Exports
module.exports = exports;
